<template>
  <div class="round-icon" :class="[background, {'disabled': disabled}]">
    <i :class="'sofont ' + icon"></i>
  </div>
</template>

<script src="./round-icon.js"></script>
<style scoped lang="scss" src="./round-icon.scss"></style>
